import React from 'react';
import styled, { withTheme } from 'styled-components';
import { translate } from 'react-i18next';
import SingleMetric from './SingleMetric';
import type { DateRange } from '../../../domain/reach';
import { TimeResolution, convertSeconds } from '../domain/TimeResolution';

const smallIconSize = 20;

const Title = styled.span`
  width: 100%;
  text-align: center;
  font-size: 22px;
  color: ${({ theme }) => theme.colors.primaryText};
  padding-top: ${({ theme }) => theme.metrics.smallMargin}px;
`;

const MetricsWrapper = styled.div`
  display: flex;
  flex-flow: row;
`;

type Data = number | { current: number; compared: number };

type DateRangeMetricsProps = {
  dateRange: DateRange,
  totalListeningTime: Data,
  perPerson: Data,
  timeResolution: TimeResolution,
  smaller?: boolean,

  t: any,
  theme: any,
};

function humanizeTimeResolution(resolution: TimeResolution, t: any) {
  return {
    'HOURS': t('time.hours'),
    'MINUTES': t('time.minutes'),
  }[resolution];
}

const ListeningTimeDateRangeMetrics = (props: DateRangeMetricsProps) => {
  const {
    dateRange, totalListeningTime, perPerson, timeResolution, smaller, t, theme,
  } = props;

  const styles = {};
  if (smaller) {
    styles.card = { backgroundColor: theme.colors.secondaryBackground };
    styles.title = { fontSize: 18 };
    styles.metricsText = { fontSize: 22 };
    styles.metrics = { padding: 8 };
  }
  return (
    <React.Fragment>
      <Title style={styles.title}>
        {`${t('date.text', { value: dateRange.from })} - ${t('date.text', { value: dateRange.to })}`}
      </Title>
      <MetricsWrapper>
        <SingleMetric
          title={t('total')}
          value={totalListeningTime}
          converter={n => convertSeconds(n, timeResolution)}
          roundAt={2}
          suffix={humanizeTimeResolution(timeResolution, t).toLocaleLowerCase()}
          textStyle={styles.metricsText}
          wrapperStyle={styles.metrics}
          iconSize={smaller ? smallIconSize : undefined}
        />
        <SingleMetric
          title={t('averageByListener')}
          value={perPerson}
          converter={n => convertSeconds(n, timeResolution)}
          roundAt={2}
          suffix={humanizeTimeResolution(timeResolution, t).toLocaleLowerCase()}
          textStyle={styles.metricsText}
          wrapperStyle={styles.metrics}
          iconSize={smaller ? smallIconSize : undefined}
        />
      </MetricsWrapper>
    </React.Fragment>
  );
};

export default translate('metrics')(withTheme(ListeningTimeDateRangeMetrics));



// WEBPACK FOOTER //
// ./src/statsradio/modules/metrics/components/ListeningTimeDateRangeMetrics.js